/** GraphQL mutation payloads with optional `errors` (Hot Chocolate / union errors). */
export function formatPayloadErrors(
  errors: ReadonlyArray<{ message?: string | null } | null | undefined> | null | undefined,
): string {
  if (!errors?.length) return '';
  return errors
    .map((e) => e?.message)
    .filter(Boolean)
    .join('; ');
}

/** Reads `errors` from a payload object when the generated TS type omits the field. */
export function errorsFromPayload(payload: unknown): string {
  if (!payload || typeof payload !== 'object') return '';
  const errors = (
    payload as { errors?: ReadonlyArray<{ message?: string | null } | null | undefined> | null }
  ).errors;
  return formatPayloadErrors(errors);
}
